// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__bKQUI","title":"Header_title__qja2A","left":"Header_left__3_KJX","clinicName":"Header_clinicName__3cm8W"};